// extracted by mini-css-extract-plugin
export default {"uspSection":"usp-section--pFb3M","uspImage":"usp-image--njwVD","uspContent":"usp-content--xx5HA","uspImageLeft":"usp-image-left--XC-7S"};